import React from 'react';

import { WhitePanel } from '../../../../components';
import { Accordian, Group, Question, Answer, Email, Call } from './common';

export function AboutJomson() {
  return (
    <WhitePanel className="mb-4">
      <h2>About Pokhara to Jomsom Flights</h2>
      <p>
        Pokhara to Jomsom Flight is your fastest alternative to entering the
        Trans Himalayan Region of Upper Mustang and the sacred pilgrimage site
        of Muktinath. This short flight from the lake city of Pokhara is more
        like a 20-minute soar high across the scenic mountain ranges if you know
        which side to get seated on (which is- Right). Jomsom Airport (2,740 m)
        lies in the picturesque town of Jomsom with Kali Gandaki flowing right
        beside it. Being administrative headquarter of Mustang, this windy town
        has everything- from luxurious lodges, quality restaurants, banks,
        health posts, ACAP center to motorbike repair centers. Also, not to
        forget- some great smelling bakeries!</p>
        
        <p>Quick Tip- Always book an early flight as there’s a high chance of flights getting interrupted due to
        powerful wind currents in the afternoon. </p>
        <p>If you are looking for activities to do while in Jomsom, or if your flight gets canceled these
        are what you can do: 
        <ol className="counter">
          <li>Visit Dhumba lake. (2 hours- one way from Jomsom)</li>
          <li>Take a quick short tour to the small white-washed village of Marpha which is famous for its Apples, Apple liquors, and Thakali culture.</li>
        </ol>
      </p>
      <p>Alternatives to Jomsom Flights- If you have extra days to spare and wish to save bucks, you can opt for road transportation as roads well connect Jomsom. We bet these winding roads will give you an adventurous ‘Thrill in the hills’ experience:
        <ol>
          <li>
            Direct buses take you directly from Kathmandu to Jomsom in 17 hours. Generally, these direct buses leave at around 2:30 pm from Kathmandu and reach Jomsom at 8 am in the morning! The fare of direct bus service is NRs. 1900 (~USD 18)
          </li>
          <li>
          Renting private jeeps is another option. The tentative cost of hiring a jeep from Kathmandu to Jomsom starts from USD 455 (3 nights/4 days) or USD 320 (1 night/ 2 days) from Pokhara to Jomsom and accommodates up to 7 people.
          </li>
          <li>Renting a motorbike is another adventurous option you can take. The tentative motorbike rental cost ranges from $15 to $55 per day.</li>
        </ol>
      </p>
    </WhitePanel>
  );
}

export function JomsomFAQ({ isOpen = true }) {
  return (
    <Accordian title="Jomsom Flight Details" isOpen={isOpen}>
      <Group>
        <Question question="How much does a flight to Jomsom cost?" />
        <Answer>
          The standard fare is USD 116.95.
        </Answer>
      </Group>

      <Group>
        <Question question="How long is the Pokhara to Jomsom Flight?" />
        <Answer>
          20 minutes. Jomsom is 67 kilometers from Pokhara in a straight line.
          Make sure to book the earliest flight you can get. As the day
          progresses, the weather in the mountains gets unstable which increases
          the chance of flight cancellations.
        </Answer>
      </Group>

      <Group>
        <Question question="What is the baggage allowance for a Pokhara to Jomsom flight?" />
        <Answer>
          Check-in Baggage: 10 kilograms. Or for the metrically challenged
          citizens, 22 lbs. 2 pieces tops. Hand Carry: 5 kilograms. 11 lbs.
          Excess baggage is charged at the rate of USD 1 per kg.
        </Answer>
      </Group>

      <Group>
        <Question question="Do I need to confirm my flight booking?" />
        <Answer>
          No. Once your flight is booked, you do not need to reconfirm it. As
          soon as the booking process is complete, you will receive an email
          with an e-ticket and necessary details of your confirmed booking. If
          you do not receive tickets within 30 minutes, we request you to check
          your spam folder first, and then email us at
          <Email /> or <Call />{' '}
          if you still don't have it.
        </Answer>
      </Group>

      <Group>
        <Question question="Do I need to print my ticket?" />
        <Answer>
          No. You can simply show your e-ticket at the Airport Counter via any
          devices like phone or tablet. However, please make sure that you have
          downloaded the tickets and there’s no issue with device battery.
        </Answer>
      </Group>

      <Group>
        <Question question="How early should I get to the Airport for catching my flight?" />
        <Answer>
          It is advised to reach to the Airport one hour before the flight time.
        </Answer>
      </Group>
    </Accordian>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Flights/SearchAndResults/StaticSections/Jomsom.js